import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DiJava,
} from "react-icons/di";
import {
  TbSql,
} from "react-icons/tb"; 
import {
  SiCsharp,
  SiCplusplus,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiPython,
  SiMarkdown,
  SiHtml5,
  SiCss3
} from "react-icons/si";
import {
  BsRegex
} from "react-icons/bs"; 

function Techstack() {
  const icons = [
    { Icon: SiCsharp, name: "C#" },
    { Icon: SiCplusplus, name: "C++" },
    { Icon: SiHtml5, name: "HTML5" },
    { Icon: SiCss3, name: "CSS3" },
    { Icon: SiJavascript, name: "JavaScript" },
    { Icon: SiTypescript, name: "TypeScript" },
    { Icon: SiReact, name: "React JSX" },
    { Icon: SiPython, name: "Python" },
    { Icon: DiJava, name: "Java" },
    { Icon: SiMarkdown, name: "Markdown" },
    { Icon: TbSql, name: "SQL" },
    { Icon: BsRegex, name: "Regex" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {icons.map((iconObj, index) => (
        <Col key={index} xs={4} md={2} className="tech-icons">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-${index}`}>{iconObj.name}</Tooltip>}
          >
            <span>
              <iconObj.Icon />
            </span>
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
